import React from "react"
import {
  Button,
  TextField,
  Grid,
  Typography,
  Box,
  IconButton,
  Switch,
  InputAdornment,
  MenuItem,
  Fab,
} from "@material-ui/core"
import {
  Receipt_Icon as Receipt,
  Receipt_NotFound,
  Sending_Receipt,
  Download
} from "./Icons"
import { ArrowDownward } from "@material-ui/icons"
import {
  StyleMainHeaderWrapper,
  StyleMainContentWrapper,
  StyleMainUIWrapper,
  StyleReceiptMainWrapper,
  StyleReceiptItemWrapper,
  StyleReceiptItemListWrapper,
  StyleReceiptCardItemWrapper,
} from "./styles"
import ScrollTopButton from "./ScrollTopButton"
import moment from "moment"
import { Formik } from "formik"
import * as Yup from "yup"
import BillImage from "./bill.png"
import package_icon from "./package_icon.png"
import phone_icon from "./phone_icon.png"
import email_icon from "./email_icon.png"
import apple_gpay from "./appleandgpay.png"
import TabAnimation from "./Tab_Animation"
import Digit7_logo from "./Digit7_logo.svg"
import Digit_Black from "./Digit_White.png"
import Mart from "./Mart.png"
import Cooler from "./Cooler.png"
import { ChevronLeft } from "@material-ui/icons"
import CircularProgress from "@material-ui/core/CircularProgress"
import { TRANSACTION_STATUS_POSITIVE_LIST } from "./fixture"

const FORCE_PAYMENT_COMPLETED = TRANSACTION_STATUS_POSITIVE_LIST.map((status) =>
  status.toLowerCase()
)
const renderLogoAnim = () => {
  return (
    <div style={{ paddingTop: 0 }}>
      <div style={{ display: "flex", margin: "auto", width: "fit-content" }}>
        <img
          style={{ height: 16, width: "auto" }}
          src={Digit_Black}
          alt="Image 1"
        />
        <div class="slider" style={{ marginLeft: 5 }}>
          <img
            style={{ height: 16, width: "auto" }}
            src={Mart}
            class="slide slide1"
            alt="Image 1"
          />
          <img
            style={{ height: 16, width: "auto" }}
            src={Cooler}
            class="slide slide2"
            alt="Image 2"
          />
        </div>
      </div>
    </div>
  )
}
export const renderHeader = (props) => {
  return (
    <StyleMainHeaderWrapper>
      <svg
        style={{ height: "30px", width: "auto", marginLeft: 20 }}
        id="a"
        viewBox="0 0 1171.93 311"
      >
        <defs>
          <linearGradient
            id="b"
            x1="93.47"
            y1="231.86"
            x2="298.12"
            y2="49.52"
            gradientTransform="translate(0 267.5) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".38" stop-color="#de127f"></stop>
            <stop offset="1" stop-color="#bc24bf"></stop>
          </linearGradient>
        </defs>
        <rect class="d" x=".25" y=".25" width="1171.43" height="310.5"></rect>
        <g>
          <path
            class="e"
            d="M361.8,143.97v91.32h105.56c7.7,0,14.95-.9,21.29-3.16,6.34-2.26,11.78-5.43,16.31-9.49,4.98-4.07,8.16-9.49,10.87-15.37,2.27-5.88,3.63-13.11,3.63-20.8v-51.54c0-7.69-.91-14.92-3.63-20.8-2.72-6.33-6.34-11.3-10.87-15.37-4.53-4.07-9.97-7.23-16.31-9.49-6.79-2.26-13.59-3.16-21.29-3.16h-105.56v33h98.76c5.89,0,10.87,1.81,14.04,4.97,3.17,3.16,4.99,7.69,4.99,14.01v44.76c0,6.33-1.81,10.85-4.99,14.01-3.17,3.16-8.15,4.97-14.04,4.97h-58.9v-57.87h-39.87Zm180.77-57.87V234.84h39.87V86.11h-39.87Zm102.84,96.75c0,6.33,1.81,10.85,4.98,14.01,3.17,3.16,8.16,4.97,14.04,4.97h39.42c5.89,0,10.87-1.81,14.04-4.97,3.17-3.62,4.98-8.14,4.98-13.56v-32.1h39.87v35.26c0,7.69-1.36,14.92-3.63,20.8-2.72,5.88-5.89,11.3-10.87,15.37-4.53,4.07-9.96,7.23-16.31,9.49-6.34,2.26-13.59,3.16-21.3,3.16h-53.46c-7.7,0-14.5-.9-21.29-3.16-6.8-2.26-11.78-5.42-16.31-9.49-4.53-4.07-8.15-9.04-10.87-15.37-2.72-5.88-3.62-13.11-3.62-20.8v-51.54c0-7.69,1.36-14.92,3.62-20.8,2.27-5.88,5.89-10.85,10.87-15.37,4.98-4.52,9.97-7.23,16.31-9.49,6.34-2.26,13.59-3.16,21.29-3.16h106.02v33h-98.77c-11.32,0-17.67,4.97-18.57,15.37v48.37h-.45Zm140.45-96.75V234.84h39.87V86.11h-39.87Zm63.42,33v-33h142.26v33h-51.2v115.73h-39.87V119.11h-51.19Zm253.71,0l-82,115.73h48.02l85.18-118.45v-30.29h-139.54v33h88.35Z"
          ></path>
          <path
            class="c"
            d="M232.59,21.91L54.8,70.16c-41.06,11.14-49.98,44.98-19.82,74.89,0,0,71.42,71.73,101.28,100.55,8.55,8.28,13.15,3.5,15.33-2.98l29.24-106.9s4.39-15.72-13.2-10.95c-10.26,2.79-56.82,15.42-56.82,15.42-12.1,3.28-24.31-4.01-27.49-15.71-3.28-12.07,4.04-24.27,19.8-28.55l97.51-26.46c30.43-8.26,37.12,13.49,32.82,29.58l-38.12,137.98c-4.33,18.85-10.92,49.7,32.13,64.72l60.1-225.24c10.9-41.05-13.91-65.74-54.96-54.6Z"
          ></path>
        </g>
      </svg>
      <div
        style={{
          marginLeft: 15,
          marginRight: 15,
          color: "#fff",
          fontWeight: "100",
          fontSize: 10,
        }}
      >{`|`}</div>
      {renderLogoAnim()}
    </StyleMainHeaderWrapper>
  )
}

const Formkit = (props) => {
  const {
    getLoader = false,
    onClose = () => "",
    initialValues,
    validationSchema,
    onSubmit,
    getReceiptCountryList,
    setReceiptCountrySelected,
  } = props || {}

  // console.log("getReceiptCountryList", getReceiptCountryList)

  const handleSubmit = (values, actions) => {
    console.log("Submitted Values:", values)
  }

  const SubForm = (subProps) => {
    const { formikUI } = subProps || {}
    React.useEffect(() => {
      const url = window?.location?.href || ""
      const parsedUrl = new URL(url)
      const queryParams = Object.fromEntries(parsedUrl.searchParams.entries())
      let defaultCountryCode = queryParams?.country_code || ""
      if (!defaultCountryCode) return
      const [_getReceiptCountryItem = {}] =
        getReceiptCountryList?.filter(
          (itm) =>
            itm?.country_code?.toLocaleLowerCase() ===
            defaultCountryCode?.toLocaleLowerCase()
        ) || []
      let defaultCountry = _getReceiptCountryItem?.country_name || ""

      // Wait until countries are loaded so URL country_code maps correctly
      if (!defaultCountry) return

      if (!formikUI?.values?.country) {
        formikUI?.setFieldValue("country", defaultCountry)
        setReceiptCountrySelected(defaultCountry)
      } else {
        // Keep selected country in sync for API country-code headers
        setReceiptCountrySelected(formikUI.values.country)
      }
    }, [getReceiptCountryList])
    let max_date = new Date().toISOString().split('T')[0]
    let next_date = moment(max_date).add(1, "day").format('YYYY-MM-DD')
    return (
      <>
        <form onSubmit={formikUI.handleSubmit}>
          <Box>
            <Grid
              style={{
                marginTop: 48,
                marginBottom: 10,
                flexDirection: "column",
              }}
            >
              <Grid
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "auto",
                  width: "fit-content",
                  marginBottom: 12,
                }}
                className="cls-sub-header-kit"
              >
                <Typography
                  style={{ marginRight: 14, fontSize: 26 }}
                >{`Get Your Receipt`}</Typography>
                <Receipt />
              </Grid>
              <Typography
                style={{
                  textAlign: "center",
                  width: "100%",
                  marginBottom: 4,
                  fontSize: 15,
                  color: "#6e6e6e",
                }}
              >{`Select Payment Method`}</Typography>
              <TabAnimation
                defaultTabView={formikUI?.values?.payment_method}
                onUpdate={(propsKit) => props?.onUpdateTab(propsKit, formikUI)}
              />
            </Grid>
            {/* Date of Store Visit */}
            <Grid sx={{ mb: 3 }} style={{ marginBottom: 20 }}>
              <Typography
                style={{
                  fontWeight: "700",
                  fontStyle: "normal",
                  fontSize: 13,
                  marginBottom: 8,
                }}
              >
                Country <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                style={{ background: "white" }}
                InputLabelProps={{
                  shrink: false,
                }}
                sx={{
                  "& .MuiInputLabel-root": {
                    display: "none",
                  },
                  "& .MuiOutlinedInput-notchedOutline legend": {
                    display: "none",
                  },
                }}
                variant="outlined"
                select
                placeholder="Select Country"
                name="country"
                value={formikUI.values.country}
                onChange={(e, d) => {
                  setReceiptCountrySelected(e?.target?.value)
                  formikUI.handleChange(e, d)
                }}
                onBlur={formikUI.handleBlur}
                error={
                  formikUI.touched.country && Boolean(formikUI.errors.country)
                }
                helperText={formikUI.touched.country && formikUI.errors.country}
                fullWidth
                size="small"
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (selected) =>
                    selected ? (
                      selected
                    ) : (
                      <span style={{ color: "#9e9e9e" }}>Select Country</span>
                    ),
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                      },
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  {"Select Country"}
                </MenuItem>
                {getReceiptCountryList?.map((item, i) => (
                  <MenuItem
                    key={item?.country_name + i + 1}
                    value={item?.country_name}
                  >
                    {item?.country_name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {/* Date of Store Visit */}
            <Grid sx={{ mb: 3 }} style={{ marginBottom: 20 }}>
              <Typography
                style={{
                  fontWeight: "700",
                  fontStyle: "normal",
                  fontSize: 13,
                  marginBottom: 8,
                }}
              >
                Date of Store Visit <span style={{ color: "red" }}>*</span>
              </Typography>

              <TextField
                style={{ background: "white" }}
                variant="outlined"
                size="small"
                type="date"
                name="date_store_visit"
                value={formikUI.values.date_store_visit}
                onChange={formikUI.handleChange}
                onBlur={formikUI.handleBlur}
                error={
                  formikUI.touched.date_store_visit &&
                  Boolean(formikUI.errors.date_store_visit)
                }
                helperText={
                  formikUI.touched.date_store_visit &&
                  formikUI.errors.date_store_visit
                }
                fullWidth
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  style: {
                    textTransform: "uppercase",
                  },
                  max: next_date,
                }}
              />
            </Grid>

            {/* Last 4 Digits Card Mask */}
            <Grid sx={{ mb: 3 }} style={{ marginBottom: 30 }}>
              <Typography
                style={{
                  fontWeight: "700",
                  fontStyle: "normal",
                  fontSize: 13,
                  marginBottom: 8,
                }}
              >
                {`Last Four Digits of the ${formikUI?.values?.payment_method === 0
                  ? "Card"
                  : "Apple Pay / Google Pay Card Number"
                  } `}
                <span style={{ color: "red" }}> *</span>
              </Typography>

              <TextField
                style={{ background: "white" }}
                variant="outlined"
                size="small"
                name="last_four"
                value={formikUI.values.last_four}
                // value={
                //   formikUI.values.last_four
                //     ? `**** **** **** ${formikUI.values.last_four}`
                //     : ""
                // }
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(-4)
                  formikUI.setFieldValue("last_four", value)
                }}
                onBlur={formikUI.handleBlur}
                error={
                  formikUI.touched.last_four &&
                  Boolean(formikUI.errors.last_four)
                }
                helperText={
                  formikUI.touched.last_four && formikUI.errors.last_four
                }
                fullWidth
                inputProps={{
                  maxLength: 4,
                }}
                placeholder="0000"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ fontSize: 16 }}>
                      {"**** **** ****"}
                    </InputAdornment>
                  ),
                }}
              />

              {formikUI?.values?.payment_method !== 0 && (
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  style={{ marginTop: 10, marginBottom: 10 }}
                >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                  // style={{ width: "100%" }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: 20,
                      }}
                      src={apple_gpay}
                      alt="Apple Pay / Google Pay Card Number"
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>

            {/* Expiration Date */}

            {/* <Grid style={{ marginBottom: 20 }} sx={{ mb: 3 }}>
              <Typography
                style={{
                  fontWeight: 700,
                  fontSize: 13,
                  marginBottom: 12,
                }}
              >
                {`Expiration Date`}
                <span
                  style={{
                    fontSize: formikUI?.values?.payment_method === 0 ? 12 : 12,
                    color:
                      formikUI?.values?.payment_method === 0 ? "gray" : "gray",
                  }}
                >{`${formikUI?.values?.payment_method === 0
                  ? " (Optional)"
                  : " (Optional)"
                  }`}</span>
              </Typography>

              <Grid container spacing={2}>
                
                <Grid item xs={5}>
                  <TextField
                    style={{ background: "white" }}
                    variant="outlined"
                    select
                    label="Month"
                    name="expiration_month"
                    value={formikUI.values.expiration_month}
                    onChange={formikUI.handleChange}
                    onBlur={formikUI.handleBlur}
                    error={
                      formikUI.touched.expiration_month &&
                      Boolean(formikUI.errors.expiration_month)
                    }
                    helperText={
                      formikUI.touched.expiration_month &&
                      formikUI.errors.expiration_month
                    }
                    fullWidth
                    size="small"
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                          },
                        },
                      },
                    }}
                  >
                    {[...Array(12)].map((_, i) => (
                      <MenuItem
                        key={i + 1}
                        value={String(i + 1).padStart(2, "0")}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

            
                <Grid item xs={5}>
                  <TextField
                    style={{ background: "white" }}
                    variant="outlined"
                    select
                    label="Year"
                    name="expiration_year"
                    value={formikUI.values.expiration_year}
                    onChange={formikUI.handleChange}
                    onBlur={formikUI.handleBlur}
                    error={
                      formikUI.touched.expiration_year &&
                      Boolean(formikUI.errors.expiration_year)
                    }
                    helperText={
                      formikUI.touched.expiration_year &&
                      formikUI.errors.expiration_year
                    }
                    fullWidth
                    size="small"
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                          },
                        },
                      },
                    }}
                  >
                    {[...Array(31)].map((_, i) => {
                      const currentYear = new Date().getFullYear()
                      const year = currentYear - 6 + i 

                      return (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      )
                    })}
                  </TextField>
                </Grid>
              </Grid>
            </Grid> */}

            {/* Email */}
            {/* <Grid sx={{ mb: 3 }} style={{ marginBottom: 20 }}>
                  <Typography
                    style={{
                      fontWeight: "700",
                      fontStyle: "normal",
                      fontSize: 13,
                      marginBottom: 8,
                    }}
                  >
                    Email ID <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <TextField
                    style={{ background: "white" }}
                    variant="outlined"
                    size="small"
                    name="email_id"
                    type="email"
                    value={formikUI.values.email_id}
                    onChange={formikUI.handleChange}
                    onBlur={formikUI.handleBlur}
                    placeholder="Enter Email Id"
                    error={
                      formikUI.touched.email_id &&
                      Boolean(formikUI.errors.email_id)
                    }
                    helperText={
                      formikUI.touched.email_id && formikUI.errors.email_id
                    }
                    fullWidth
                  />
                </Grid> */}
          </Box>

          <Box display="flex" gap={2}>
            <Button
              className="cls-button-mode"
              variant="outlined"
              onClick={() => props?.handleBackToReceipt(formikUI)}
              // onClick={formikUI.resetForm}
              // disabled={formikUI.isSubmitting}
              style={{
                width: "calc(50% - 14px)",
                marginRight: 15,
                borderColor: "var(--receipt-button-secondary-color)",
                color: "var(--receipt-button-secondary-color)",
              }}
            >
              {`Reset`}
            </Button>

            <Button
              type="submit"
              variant="contained"
              disabled={getLoader}
              className="cls-button-mode"
              style={{
                width: "50%",
                backgroundColor: getLoader ? "#7c7c7c" : "var(--receipt-button-secondary-color)",
                color: "#fff",
              }}
            // onClick={(e) => e.stopPropagation()}
            >
              {getLoader ? "Processing..." : "Find Receipt"}
            </Button>
          </Box>
        </form>
        {props?.getLoader ? (
          <div
            style={{ marginTop: 20, width: "100%", textAlign: "center" }}
          >{`Retrieving Receipt...`}</div>
        ) : props?.getFlagFormSubmit?.flag === true ? (
          renderReceiptError(props, formikUI)
        ) : (
          renderReceiptList(props)
        )}
      </>
    )
  }
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(formikUI) => {
        return <SubForm formikUI={formikUI} />
      }}
    </Formik>
  )
}

export const renderFormUI = (props) => {
  return <Formkit {...props} />
}

export const renderReceiptItem = (item, props) => {
  const {
    receiptNo = 1,
    transactionId = "XXXXX",
    storeInfo = "",
    dateInfo = "",
    customerName = "",
    customerSubText = "",
    customerText = "",
    cartList = [],
    companyInfo = {},
    returnText = "",
    cartInfo = {},
    receiptShow = false,
    transactionTime = "",
    transaction_status = "",
    currencySymbol = "$",
  } = item || {}

  let getCurrency = currencySymbol.includes("AED")
    ? `${currencySymbol} `
    : currencySymbol

  const { handleDownloadToReceipt = () => "", getDownloadingId = "" } =
    props || {}
  const isDownloadingThisReceipt =
    !!transactionId && getDownloadingId === transactionId

  if (receiptShow === false) {
    return <></>
  }
  const safeCartList = cartList || []
  const totalQty = safeCartList.reduce(
    (sum, i) => sum + parseInt(i.quantity),
    0
  )
  const grandTotal = safeCartList.reduce((sum, i) => sum + parseInt(i.Total), 0)

  const formatAmount = (num, currencyFlag = false) =>
    `${currencyFlag ? currencySymbol : ""}${Number(num || 0).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    )}`
  const renderReceiptHeaderItem = () => {
    return (
      <div className="receipt-header">
        <div className="header-top">
          <div className="cls-sub-error-head-content-text">
            <div className="cls-sub-error-head-content-svt-text">{`Receipt: ${transactionId}`}</div>
            <div className="cls-sub-error-head-content-svtv-text">
              {moment(transactionTime).format("DD-MMM-YYYY | hh:mm:ss A")}
            </div>
          </div>
        </div>
        <Button
          variant="outlined"
          className="cls-button-mode cls-download-button"
          startIcon={<Download />}
          disabled={isDownloadingThisReceipt}
          onClick={(e) => {

            handleDownloadToReceipt(item, e)
          }}
        >
          {"PDF"}
          {isDownloadingThisReceipt && (
            <CircularProgress
              size={15}
              style={{ marginLeft: "10px" }}
              aria-label="Loading…"
            />
          )}
        </Button>
      </div>
    )
  }

  const renderReceiptContentItem = () => {
    const renderListUI = () => {
      return (
        <StyleReceiptItemListWrapper>
          <div>
            {safeCartList.map((item, index) => (
              <StyleReceiptCardItemWrapper key={index}>
                <div className="cls-left-kit">
                  <div className="cls-product-name-kit">{item.productName}</div>
                </div>
                <div className="cls-right-kit">
                  <div className="cls-right-total-kit">
                    <div className="cls-tax-txt">
                      <div>
                        <span>{`Qty: `}</span>
                        <span className="cls-txt-bold">{`${item.quantity}`}</span>
                      </div>
                      <span>{`Price: `}</span>
                      <span className="cls-txt-bold">{`${getCurrency}${formatAmount(
                        item.productPrice
                      )}`}</span>
                    </div>
                  </div>
                  <div className="cls-right-total-kit">
                    <div className="cls-tax-txt">
                      <span>{`Tax: `}</span>
                      <span className="cls-txt-bold">{`${getCurrency}${formatAmount(
                        item.tax
                      )}`}</span>
                    </div>
                    <div className="cls-total-txt">
                      <span>{`Total: `}</span>
                      <span className="cls-txt-bold">{`${getCurrency}${formatAmount(
                        item.Total
                      )}`}</span>
                    </div>
                  </div>
                </div>
              </StyleReceiptCardItemWrapper>
            ))}
          </div>
          <div className="cls-footer-total-ui ">
            <div
              colSpan="3"
              className="footer-left"
              style={{ textAlign: "left" }}
            >
              <span>{`Total Items: `}</span>
              <strong>{cartInfo?.totalItemPurchased}</strong>
            </div>
            <div className="footer-label" style={{ textAlign: "right" }}>
              <span>{`Grand Total: `}</span>
              <strong>
                {`${getCurrency}${formatAmount(cartInfo?.totalGrand)}`}
              </strong>
            </div>
          </div>
        </StyleReceiptItemListWrapper>
      )
    }
    return (
      <div className="receipt-container-item">
        <div className="greeting">
          <h3>{`Purchase Summary :`}</h3>
        </div>
        {renderListUI()}
      </div>
    )
  }

  const renderReceiptFooter = () => {
    let PAYMENT_COMPLETED = "Payment Completed"
    let transaction_status_txt = FORCE_PAYMENT_COMPLETED.includes(
      transaction_status?.toLowerCase()
    )
      ? PAYMENT_COMPLETED
      : transaction_status
    return (
      <div className="cls-status-wrapper">
        <div
          className={`cls-status-txt-kit cls-${transaction_status_txt
            ?.toLowerCase()
            ?.replaceAll(" ", "-")}`}
        >
          <span>{transaction_status_txt}</span>
          {transaction_status_txt.includes("Failed") && (
            <span className="cls-status-subtxt-kit">{`- System might try later`}</span>
          )}
        </div>
      </div>
    )
  }
  return (
    <StyleReceiptItemWrapper>
      <div className="receipt-wrapper-kit">
        {renderReceiptHeaderItem()}
        {renderReceiptContentItem()}
        {renderReceiptFooter()}
      </div>
    </StyleReceiptItemWrapper>
  )
}
export const renderEmailCapture = (props) => {
  const {
    getCustomerEmail = "",
    getCustomerEmailError = "",
    setCustomerEmail,
    getCustomerEmailSubmitDisabled = true,
    getEmailSubmitting = false,
    onCustomerEmailChange = () => "",
    onCustomerEmailBlur = () => "",
    onSubmitCustomerEmail = () => "",
    getemailFocus = false,
    setemailFocus,
  } = props || {}
  console.log(`email,focus`, getCustomerEmail.length, getemailFocus)
  return (
    <div className="cls-email-capture">
      <div className="cls-email-capture-head">
        <div className="cls-email-capture-icon" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path
              d="M7 3.5h10M7 20.5h10"
              stroke="#A62991"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <path
              d="M8 3.5c.2 3.2 1.6 5.1 4 7.2 2.4 2.1 3.8 4 4 7.3M16 3.5c-.2 3.2-1.6 5.1-4 7.2-2.4 2.1-3.8 4-4 7.3"
              stroke="#A62991"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div>
          <div className="cls-email-capture-title">
            Your recent receipt is being processed.
          </div>
          <div className="cls-email-capture-sub">
            Enter your email and we’ll send it once it’s ready.
          </div>
        </div>
      </div>
      <label
        className="cls-email-capture-label"
        htmlFor="receipt-customer-email"
      >
        Email Address<span>*</span>
      </label>
      <input
        autoFocus={getemailFocus}
        id="receipt-customer-email"
        className="cls-email-capture-input"
        type="email"
        name="customer_email"
        placeholder="Enter your email address"
        value={getCustomerEmail}
        autoComplete="email"
        aria-invalid={Boolean(getCustomerEmailError)}
        onChange={(event) => {
          onCustomerEmailChange(event.target.value)
        }}
        onBlur={onCustomerEmailBlur}
        onKeyDown={(event) => {
          setemailFocus(true)
          if (event.key === "Enter") {
            event.preventDefault()
            if (!getCustomerEmailSubmitDisabled) {
              onSubmitCustomerEmail()
            }
          }
        }}
      />
      {getCustomerEmailError ? (
        <div className="cls-email-capture-error" role="alert">
          <span className="cls-email-capture-error-icon">!</span>
          {getCustomerEmailError}
        </div>
      ) : null}
      <button
        type="button"
        className="cls-email-capture-submit"
        disabled={getCustomerEmailSubmitDisabled}
        onClick={onSubmitCustomerEmail}
        style={{
          transform: getCustomerEmail.length === 0 ? 'none' : undefined,
          transition: getCustomerEmail.length === 0 ? 'none' : undefined
        }}
      >
        {getEmailSubmitting ? "Submitting..." : "Submit"}
      </button>
    </div >
  )
}

export const renderReceiptList = (props) => {
  const {
    getReceiptList = [],
    cf = {},
    getReceiptRef = null,
    getShowEmailCapture = false,
  } = props || {}

  return (
    <StyleReceiptMainWrapper style={{ marginTop: 50 }} ref={getReceiptRef}>
      {getShowEmailCapture ? renderEmailCapture(props) : null}
      {getReceiptList.length > 0 ? (
        getReceiptList.map((getReceiptItem) => {
          const {
            receiptPendingShow = false,
            receiptPositiveShow = false,
            transaction_status = "",
          } = getReceiptItem || {}
          const isPositiveReceipt =
            receiptPositiveShow ||
            FORCE_PAYMENT_COMPLETED.includes(
              String(transaction_status || "").toLowerCase()
            )

          if (isPositiveReceipt) {
            return renderReceiptItem(
              { ...getReceiptItem, receiptShow: true },
              props
            )
          }

          /* DONT REMOVE THIS COMMENT */
          /*  
          DONT REMOVE THIS COMMENT
          renderReceiptError(
                { ...props, directPage: true, messageKit: cf["3"] },
                {},
                getReceiptItem
              ) */

          return receiptPendingShow ? (
            <></>
          ) : (
            renderReceiptItem(getReceiptItem, props)
          )
        })
      ) : (
        <div className="cls-sub-no-receipt-content">
          <Receipt_NotFound />
          <div className="cls-sub-error-content-text">
            <div className="cls-sub-error-content-head-text">{cf["2"]}</div>
          </div>
        </div>
      )}
    </StyleReceiptMainWrapper>
  )
}

export const renderReceiptError = (props, formikUI, currentItem) => {
  const { directPage = false, messageKit = "" } = props || {}
  const { transactionTime = "", heading = "", subHeading = "" } =
    currentItem || {}
  const renderPageBackSubHeader = () => {
    return (
      <IconButton
        style={{ padding: 0 }}
        onClick={() => props?.handleBackToReceipt(formikUI)}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "fit-content",
          }}
        >
          <ChevronLeft
            style={{
              transform: "rotate(90deg)",
              fill: "#8e2c8f",
              width: 30,
              height: 30,
            }}
          />
          <span style={{ fontSize: 15 }}>{`Go to Search`}</span>
        </div>
      </IconButton>
    )
  }
  const renderSubErrorContent = () => {
    let messageKitText = directPage
      ? messageKit
      : props?.getFlagFormSubmit?.message
    return (
      <div className="cls-sub-error-content">
        {!messageKitText.includes("No receipts found") && (
          <div className="cls-sub-error-head-content-text">
            <div className="cls-sub-error-head-content-svt-text">{`Store Your Visited Time: `}</div>
            <div className="cls-sub-error-head-content-svtv-text">
              {moment(transactionTime).format("DD-MMM-YYYY | hh:mm:ss A")}
            </div>
          </div>
        )}
        <div className="cls-sub-error-head-content-svg">
          {messageKitText.includes("No receipts found") ? (
            <Receipt_NotFound />
          ) : (
            <Sending_Receipt />
          )}
        </div>
        <div className="cls-sub-error-content-text">
          <div className="cls-sub-error-content-head-text">
            {messageKitText.includes("No receipts found")
              ? messageKitText
              : heading}
          </div>
          {!messageKitText.includes("No receipts found") && (
            <div className="cls-sub-error-content-subhead-text">
              {subHeading}
            </div>
          )}
        </div>
        {directPage === false && (
          <Button
            variant="contained"
            onClick={() => props?.handleBackToReceipt(formikUI)}
            className="cls-button-mode"
            style={{
              width: "70%",
              backgroundColor: "var(--receipt-button-secondary-color)",
              color: "#fff",
              margin: "auto",
              marginTop: 20,
            }}
          >
            {"RETURN TO SEARCH"}
          </Button>
        )}
      </div>
    )
  }
  return (
    <div style={{ marginTop: 30 }}>
      {directPage === false && renderPageBackSubHeader()}
      {renderSubErrorContent()}
    </div>
  )
}
export const renderContent = (props) => {
  return (
    <StyleMainContentWrapper>{renderFormUI(props)}</StyleMainContentWrapper>
  )
}

export const renderUI = (props) => {
  return (
    <StyleMainUIWrapper>
      {renderHeader(props)}

      {renderContent(props)}
      <ScrollTopButton />
    </StyleMainUIWrapper>
  )
}
